import { useState } from "react";
import { StyledBurger, StyledMenu } from "../../layout/MobileStyle";
import HealthtrackaLogo from "../../../assets/img/healthtracka-logo.svg";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { organisationNavMenu } from "../../../data/utils";
import { BaseButton } from "../../base";
import { emptyLocalStorage, emptySessionStorage } from "../../../utils/browserStorage";
import { resetNewBookingData } from "../../../store/slices/organisation";
import { useAppDispatch } from "../../../store";

const OrganisationHeader = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const dispatch = useAppDispatch();

    const closeBurger = () => {
        setOpen(!open);
    };
    const Logout = () => {
        setIsProcessing(true);
        emptySessionStorage();
        emptyLocalStorage();
        dispatch(resetNewBookingData());
        navigate("/login");
        setIsProcessing(false);
    };
    return (
        <div className="bg-white fixed top-0 w-full lg:hidden z-[998] py-6 transition shadow">
            <header className="w-full  bg-white items-center justify-between lg:px-12 px-4 transition  ">
                <div className="flex lg:mt-[2px] justify-between items-center">
                    <div className="w-fit lg:hidden lg:mt-[2px] md-x:mt-0 cursor-pointer">
                        <Link to="/">
                            <img
                                src={HealthtrackaLogo}
                                alt="logo"
                                className="w-[150px]"
                            />
                        </Link>
                    </div>
                    <div className="lg:flex lg:justify-between items-center lg:w-full">
                        <div
                            className={`flex h-auto lg:hidden lg:py-4 lg:mt-0 bg-white w-full items-center z-50 transition`}
                        >
                            <div className="lg:hidden flex items-center">
                                <div></div>
                                <StyledBurger open={open} onClick={closeBurger}>
                                    <div />
                                    <div />
                                    <div />
                                </StyledBurger>
                                <div>
                                    <StyledMenu
                                        className=" !bg-[#F4F6FC] !w-4/6  md:!w-3/6  !top-0 "
                                        onClick={closeBurger}
                                        open={open}
                                    >
                                        <div className="w-fit lg:mt-[2px] py-6 md-x:mt-0 cursor-pointer">
                                            <img
                                                src={HealthtrackaLogo}
                                                alt="logo"
                                                className="w-[150px]"
                                            />
                                        </div>
                                        {organisationNavMenu
                                            .filter(
                                                (res) => res.active === true
                                            )
                                            .map((nav, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={` flex textbrandColor gap-1 py-4 cursor-pointer ${
                                                            !nav.active &&
                                                            "cursor-not-allowed opacity-50"
                                                        }`}
                                                    >
                                                        <img
                                                            src={nav.icon}
                                                            alt="icon"
                                                            className="w-[25px]"
                                                        />
                                                        <Link
                                                            to={nav.route}
                                                            onClick={
                                                                closeBurger
                                                            }
                                                            // className={`${
                                                            //     nav.route ===
                                                            //     pathname
                                                            //         ? "text-[#0C4654]"
                                                            //         : "text-[#94A3B5]"
                                                            // }`}
                                                        >
                                                            <span className="">
                                                                {" "}
                                                                {nav.name}
                                                            </span>
                                                        </Link>
                                                    </div>
                                                );
                                            })}
                                        <BaseButton
                                            text="Log out"
                                            type="submit"
                                            variant="neutral"
                                            styles=" w-3/5 mx-1 mt-20  font-bold border-2px"
                                            click={Logout}
                                            processing={isProcessing}
                                        />
                                    </StyledMenu>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
};

export default OrganisationHeader;
